function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.17904 48.4725C5.85116 49.336 5.96045 50.3075 6.61623 51.0631C7.27201 51.8187 8.25568 52.1426 9.13005 51.9267L14.0484 50.9552L16.4529 55.4888C16.8901 56.3523 17.7645 56.8921 18.7481 56.8921C18.8574 56.8921 18.8574 56.8921 18.8574 56.8921C19.9504 56.8921 20.8248 56.2444 21.1526 55.3809L24.8687 46.5295C18.9667 45.9898 13.7205 43.3992 9.78582 39.6212L6.17904 48.4725ZM44.2142 39.6212C40.2795 43.3992 35.0333 45.9898 29.1313 46.5295L32.7381 55.3809C33.1752 56.2444 34.0496 56.8921 35.1426 57C35.1426 56.8921 35.1426 56.8921 35.2519 56.8921C36.2355 56.8921 37.1099 56.4603 37.5471 55.4888L39.9516 50.9552L44.87 51.9267C45.7443 52.1426 46.728 51.8187 47.3838 51.0631C48.0396 50.3075 48.1488 49.336 47.821 48.4725L44.2142 39.6212Z",
  fill: "#008AFF"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_4313_60856)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.0083 2L30.2164 4.7013L34.0453 3.1439L36.3219 6.67532L40.4613 6.25974L41.5996 10.3117L45.6355 11.1439L45.532 15.2997L49.154 17.3766L47.9111 21.3247L50.8087 24.3377L48.4296 27.7662L50.2923 31.5065L46.9808 34.1039L47.7052 38.2597L43.7728 39.7153L43.2543 43.8712L39.116 44.079L37.3568 47.9221L33.3209 46.8831L30.5268 50L26.9049 47.8192L23.2829 50L20.4888 46.8831L16.453 47.9221L14.6937 44.079L10.5554 43.8712L10.0369 39.7153L6.10349 38.2597L6.82892 34.1039L3.51742 31.5065L5.38014 27.7662L3 24.3377L5.89859 21.3247L4.65575 17.3766L8.2777 15.2997L8.17421 11.1439L12.2101 10.2078L13.3484 6.15584L17.4878 6.57143L19.869 3.1439L23.6968 4.7013L27.0083 2ZM14.2066 22.2988V30.091C14.2066 32.3312 15.361 33.5975 17.4774 33.5975C19.5938 33.5975 20.7482 32.3312 20.7482 30.091V28.0445H18.6318V30.2858C18.6318 31.2598 18.1508 31.6494 17.4774 31.6494C16.804 31.6494 16.323 31.2598 16.323 30.2858V22.2014C16.323 21.2273 16.804 20.8377 17.4774 20.8377C18.1508 20.8377 18.6318 21.2273 18.6318 22.2014V23.8572H20.7482V22.2988C20.7482 20.1559 19.5938 18.7923 17.4774 18.7923C15.361 18.7923 14.2066 20.0585 14.2066 22.2988ZM22.2878 18.9868H25.3662L26.8092 29.3124L28.2522 18.9868H31.4268V33.4023H29.3104V22.4932L27.675 33.4023H25.8472L24.2118 22.4932V33.4023H22.2878V18.9868ZM39.314 18.9868H33.1581V33.4023H39.314V31.3569H35.466V26.8773H38.5453V24.8309H35.466V21.0322H39.314V18.9868Z",
  fill: "#0DFFF3"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_4313_60856",
  x: 0,
  y: 0,
  width: 53.8087,
  height: 54,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4313_60856"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_4313_60856",
  result: "effect2_dropShadow_4313_60856"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_4313_60856",
  result: "effect3_dropShadow_4313_60856"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_4313_60856",
  result: "shape"
})));

function SvgCmeSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 61,
    viewBox: "0 0 54 61",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmeSuccess);
export default __webpack_public_path__ + "static/media/cme_success.67f10e06.svg";
export { ForwardRef as ReactComponent };